import { post } from "@/util/http";
import router from "@/router/index.js";
import { store } from "@/store/index.js";
import { Message } from "element-ui";

export function enterRoom(anchor) {
  if (anchor.ticket > 0 && anchor.ticket_paid === 2 && store.state.userInfo.id !== anchor.anchorid) {
    if (!store.state.userInfo.id) {
      store.commit("toggleLogin");
      return;
    }
    store.commit("toggleTicketPayDialog", true);
    store.commit("changeTicketAnchor", anchor);
    store.commit("toggleIsNeedRefresh", isRefresh);
    // payTicket(anchor, isRefresh);
  } else {
    if (window.location.href.indexOf("liveMatchesTwo") !== -1) {
      router.push(`/liveMatchesTwo/${anchor.anchorid}`);
      window.location.reload();
    } else {
      router.push(`/liveMatchesTwo/${anchor.anchorid}`);
    }
  }
}

// function payTicket(anchor, isRefresh) {
//   post({
//     url: "/api/live/ticket",
//     data: {
//       uid: store.state.userInfo.id,
//       anchor_id: anchor.anchorid,
//     },
//   })
//     .then(({ data }) => {
//       if (data.status === 0) {
//         Message.success(`消耗入场券${anchor.ticket}张`);
//         router.push(`/liveMatchesTwo/${anchor.anchorid}`);
//         if (isRefresh) {
//           window.location.reload();
//         }
//       }
//     })
//     .catch((err) => console.log("err: ", err));
// }
